import { useGetConfig } from "@onefront/forrestjs-react-root";
// import { useTargetUrl } from "../../service-axios";
import { AccessDenied, TSLogo } from "../../images";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";
import { useTranslation } from "../../service-i18n";
import { useProxy } from "../../service-axios";

export const DefaultErrorView = ({ error }) => {
  /**
   * This version automatically redirects towards the login page.
   * in most cases it will generate a new valid session in a transparent way.
   */

  // const appId = useGetConfig("one.appId", "app3000");
  // const targetUrl = useGetConfig("one.login.target.url", "loginApp");
  // const targetUrlParams = useGetConfig("one.login.target.params", [
  //   "mode=redirect"
  // ]);
  // const { loading, url: loginUrl } = useTargetUrl(targetUrl, [
  //   ...targetUrlParams,
  //   `appId=${appId}`
  // ]);

  // if (loginUrl) {
  //   window.location.href = loginUrl;
  // }

  // return null;

  const { t } = useTranslation("react-sdk");
  const urn = useGetConfig("one.appId");
  const { createTargetUrl } = useProxy();
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ p: "32px", gap: "32px", flex: "1" }}
    >
      <TSLogo />
      <AccessDenied />
      <ExtendedTypography
        variant="display"
        gutterBottom
        component="div"
        color="primary.textTitleColor"
      >
        {t("access_denied")}
      </ExtendedTypography>
      <ExtendedTypography variant="titleMedium" color="primary.textTitleColor">
        {t("contact_admin")}
      </ExtendedTypography>
      <Button
        variant="contained"
        onClick={() => {
          window.location.href = createTargetUrl(urn, []);
        }}
      >
        {t("back_to_home")}
      </Button>
    </Stack>
  );
};
